export enum HttpStatusCodeSuccess {
  ok = 200,
  created = 201,
  accepted = 202,
  noContent = 204,
}

export enum HttpStatusCodeError {
  badRequest = 400,
  unauthorized = 401,
  forbidden = 403,
  notFound = 404,
  conflict = 409,
  unprocessableEntity = 422,
  tooManyRequests = 429,
  serverError = 500,
}

export const HttpStatusCode = {
  ...HttpStatusCodeSuccess,
  ...HttpStatusCodeError,
} as const;

export type HttpResponseError = {
  statusCode: HttpStatusCodeError;
  body: Error;
};

export type HttpResponseSuccess<T = any> = {
  statusCode: HttpStatusCodeSuccess;
  body: T;
};

export type HttpResponse<R = any> = HttpResponseSuccess<R> | HttpResponseError;

// Tipo compatível com AxiosResponse para interceptors
export type AxiosHttpResponse<T = any> = {
  data: HttpResponse<T>;
  status: number;
  statusText: string;
  headers: any;
  config: any;
};
